import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AlertMode, ProfileAlert } from "../types";

export const patchProfileAlert = (
  billingProfileId: string,
  threshold: number,
  mode: AlertMode = "projection"
) => {
  return apiProxyRequest<ProfileAlert>(
    `/billing/profiles/${billingProfileId}/alerts/billing`,
    "PATCH",
    {
      active: true,
      config: {
        threshold,
        mode
      }
    }
  );
};
